// $(document).ready(function() {
//   var $headerWrapper = $('body.index .header-wrapper');

//   // Check if the element exists
//   if ($headerWrapper.length) {
//     var header_top_offset = $headerWrapper.offset().top;
    
//     if (header_top_offset >= 200) {
//       $('.section-header').addClass('scrolled-past-header');
//       console.log("Top Position Of header", header_top_offset);
//     }
//   } else {
//     // console.log("Header wrapper not found on this page.");
//   }
// });

$(document).ready(function () {
  // When clicking the menu
  $('header.header nav ul li summary').click(function (event) {
    event.stopPropagation(); // Prevent click from bubbling up
    $('html').toggleClass('mega_menu_opens');
  });

  // Clicking anywhere outside the menu removes the class
  $(document).click(function (event) {
    if (!$(event.target).closest('header.header nav ul li summary').length && $('html').hasClass('mega_menu_opens')) {
      $('html').removeClass('mega_menu_opens');
    }
  });

  $('.menu-drawer__inner-submenu .list-menu li .menu-drawer__menu-item_dt').click(function(){
    event.stopPropagation(); // Prevent click from bubbling up
    $(this).parent().siblings().find('.menu-drawer__submenu').slideUp();
    $(this).parent().siblings().removeClass('active_menus');
    // setTimeout(function() {
        $(this).parent().toggleClass('active_menus');
        $(this).next().slideToggle();
    // }, 200);   
  })
});

if ($(window).width() <= 991){
  $('.collection_inner_info').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "58px",
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: false,
          dots: false
        }
      }
    ]
  });
}



$(window).on('load', function () {
  let currentUrl = window.location.pathname;
  $(".collection_list_items li ").each(function () {
      if ($(this).find('a').attr("href") === currentUrl) {
          $(this).addClass("active");
      }
  });
  if ($(window).width() <= 767){
    $('.pro_slick_sec').slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
    });
  }
});


// 
//   var coll_mincount = 8,
//     coll_maxcount = 8,
//     col_isLoading = false,
//     totalProducts = $(".collection #product-grid > li").length; // Get total products count[]
// console.log(totalProducts,'totalProducts');

//   $(".collection #product-grid > li").slice(coll_maxcount).hide();


// function updateLoaderProgress() {
//     let loadedProducts = $(".collection #product-grid > li:visible").length;
//     let progress = (loadedProducts / totalProducts) * 100;
//     $(".progress-circle").css("stroke-dasharray", progress + ", 100"); // Adjust SVG progress
// }

// function showLoader_col() {
//     $(".collection_product_list .loader").show();
//     $(".collection_list_sec .collection .loader").css({ opacity: "1", visibility: "visible" });
// }

// function hideLoader_col() {
//     $(".collection_list_sec .collection .loader").hide();
// }

// function hideLoader1() {
//     $(".collection_list_sec  .collection .loader").css({ opacity: "0", visibility: "hidden", display: 'none' });
// }

// $(window).scroll(function () {
//   if ($(window).scrollTop() + $(window).height() >= $(document).height() - 350 && !col_isLoading) {
//     col_isLoading = true;
//     showLoader_col();

//     setTimeout(function () {
//         $(".collection #product-grid > li").slice(coll_mincount, coll_maxcount).slideDown(450);
//         coll_mincount = coll_maxcount;
//         coll_maxcount += 8;
//         col_isLoading = false;
//         updateLoaderProgress(); // Update progress after loading
//         // hideLoader1();
//     }, 450);

//     if ($(".collection #product-grid > li:hidden").length == 0) {
//         hideLoader1();
//     }
//   }
// });

// // Append Loader with Progress Indicator
// $(".collection_list_sec .collection").append(' <li class="loader"> <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="19" cy="19" r="16" stroke="#1E1E1E" stroke-width="1.5" fill="none" opacity="0.2"/> <circle cx="19" cy="19" r="16" stroke="#181818" stroke-width="1.5" fill="none" stroke-dasharray="0, 100" class="progress-circle" stroke-linecap="round"/></li>');

// // Initialize progress indicator
// updateLoaderProgress();


// 
$('.accordion_data_title').click(function(){
  $(this).parent().siblings().removeClass('active');
  $(this).parent().siblings().find('.accordion_data_desc').slideUp();
  $(this).parent().toggleClass('active');
  $(this).next().slideToggle();
})


 $('.multi-insta-post').slick({
      centerMode: true,
      centerPadding: '240px',
      slidesToShow: 3,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 1500,
      pauseOnHover: false,
      focusOnSelect: false,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            centerMode: true,
            centerPadding: '204px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1200,
          settings: {
            centerMode: true,
            centerPadding: '150px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            centerMode: true,
            centerPadding: '100px',
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: '100px',
            slidesToShow: 2
          }
        },
         {
          breakpoint: 580,
          settings: {
            centerMode: true,
            centerPadding: '63px',
            slidesToShow: 1
          }
        },
         {
        breakpoint: 425,
        settings: {
          centerMode: true, 
          centerPadding: '63px',
          slidesToShow: 1, 
          slidesToScroll: 1, 
        },
      },
      ]
});


$('nav.menu-drawer__navigation>ul.menu-drawer__menu>li>detail>.menu-drawer__submenu').hide();
$('.menu-drawer__navigation>ul.menu-drawer__menu>li detail summar').click(function(){

    $(this).parents('.header_items').toggleClass('active');
    $(this).next().slideToggle();
})



$('.card-product-cart-wrapper .quick-add product-form button.restock-rocket-preorder-button').each(function () {
  $(this).addClass('hidden');
});
setTimeout(function () {
  $('.card-product-cart-wrapper .quick-add product-form button.restock-rocket-preorder-button').each(function () {
    $(this).removeClass('hidden');
    $(this).html(`
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 0.00390625V12.0039" stroke="#181818" stroke-width="1.8"></path>
        <path d="M12 6.00391L2.38419e-07 6.00391" stroke="#181818" stroke-width="1.8"></path>
      </svg>
    `);
  });
}, 3000);













